import type { SchemaLoanRequestResolver_GetOffersSynchronizationStatus } from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import { toast } from 'react-toastify';

import i18n from '~/lib/i18n';

export const showSynchronizationToastError = (
    warning: NonNullable<NonNullable<SchemaLoanRequestResolver_GetOffersSynchronizationStatus>['warning']>,
    t: TFunction<'de' | 'en', undefined>,
) => {
    const ToastMessage = () => (
        <div className="flex flex-col gap-1" key={`eta-validation-error-messages-container`}>
            <p className="font-medium">
                {i18n.exists(`OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.ERROR_MESSAGES.${warning}`)
                    ? // @ts-expect-error this is a workaround for the i18n type check
                      t(`OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.ERROR_MESSAGES.${warning}`)
                    : t('OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.ERROR_MESSAGES.GENERAL_UNKNOWN_ERROR')}
            </p>
        </div>
    );

    toast.error(<ToastMessage />, { theme: 'colored' });
};
